import { Pipe, PipeTransform } from '@angular/core';
import formatDistance from 'date-fns/formatDistance';

@Pipe({
  name: 'dayAgo'
})
export class DayAgoPipe implements PipeTransform {

    transform(value: Date): string {
        return formatDistance(value, new Date(), { addSuffix: true });
    }
}
